import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Departments = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '20',
    defaultHeight: '20',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      width={widthToUse}
      height={heightToUse}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.9817 12L4.94032 12L4.94032 14.6163M12.5204 12L12.5204 14.6163M20.005 12L20.005 14.6163'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.4897 11.6606L12.4897 6.86261M12.4897 6.86261C13.8705 6.86261 14.9897 5.74332 14.9897 4.36261C14.9897 2.9819 13.8705 1.86261 12.4897 1.86261C11.109 1.86261 9.98975 2.9819 9.98975 4.36261C9.98975 5.74332 11.109 6.86261 12.4897 6.86261Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.9897 19.6002C14.9897 20.9809 13.8705 22.1002 12.4897 22.1002C11.109 22.1002 9.98975 20.9809 9.98975 19.6002C9.98975 18.2195 11.109 17.1002 12.4897 17.1002C13.8705 17.1002 14.9897 18.2195 14.9897 19.6002Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.4817 19.6002C22.4817 20.9809 21.3624 22.1002 19.9817 22.1002C18.601 22.1002 17.4817 20.9809 17.4817 19.6002C17.4817 18.2195 18.601 17.1002 19.9817 17.1002C21.3624 17.1002 22.4817 18.2195 22.4817 19.6002Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.44031 19.6002C7.44031 20.9809 6.32102 22.1002 4.94031 22.1002C3.55959 22.1002 2.44031 20.9809 2.44031 19.6002C2.44031 18.2195 3.5596 17.1002 4.94031 17.1002C6.32102 17.1002 7.44031 18.2195 7.44031 19.6002Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
